export default __webpack_public_path__ + "808a5a3c484c2b2a4a38576929322229.png";